export default {
  FilterByAbuseCategory() {
    const filteredData = this.allData.filter(
      (element) => element.category === this.chosenCategory
    );
    this.abuseData = filteredData;
  },
  getMaxAbuseCount() {
    var countArray = [];
    this.abuseData.forEach((data) => countArray.push(data.count));
    return Math.max(...countArray);
  },
  orderData() {
    if (this.orderBy === "count") {
      this.orderByCount();
    } else if (this.orderBy === "name") {
      this.orderByName();
    } else if (this.orderBy === "sport") {
      this.orderBySport();
    }
  },
  setCountBarLength() {
    this.abuseData.forEach((data) => {
      const barPercent = (data.count / (this.maxCount + 500)) * 100;
      document.getElementById(data.name).style.width = barPercent + "%";
    });
  },
  orderByCount() {
    this.abuseData = this.abuseData.sort(
      (a, b) => (b.count - a.count) * this.sortDirection
    );
  },
  orderByName() {
    var sortOrder = this.sortDirection;
    this.abuseData = this.abuseData.sort(function (a, b) {
      var nameA = a.name.toUpperCase();
      var nameB = b.name.toUpperCase();
      if (nameA < nameB) {
        return -1 * sortOrder;
      }
      if (nameA > nameB) {
        return 1 * sortOrder;
      }
      return 0;
    });
  },
  orderBySport() {
    var sortOrder = this.sortDirection;
    this.abuseData = this.abuseData.sort(function (a, b) {
      var nameA = a.sport.toUpperCase();
      var nameB = b.sport.toUpperCase();
      if (nameA < nameB) {
        return -1 * sortOrder;
      }
      if (nameA > nameB) {
        return 1 * sortOrder;
      }
      return 0;
    });
  },
  humanFormat(count){
     
    return (new Intl.NumberFormat().format(count)); 

  },
};
